import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function (props) {
	const { t } = useTranslation();
	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<KeyboardDatePicker
				autoOk
				format="MM/dd/yyyy"
				fullWidth
				id="date-picker-dialog"
				invalidDateMessage={t('error_message.invalid_date')}
				KeyboardButtonProps={{
					'aria-label': 'change date'
				}}
				label={props.label || ''}
				margin="normal"
				maxDate={props.maxDate}
				maxDateMessage={props.maxDateMessage || t('error_message.default_max_date_error')}
				minDate={props.minDate}
				minDateMessage={props.minDateMessage || t('error_message.default_min_date_error')}
				onChange={props.onChange}
				onError={props.onError}
				value={props.value}
			/>
		</MuiPickersUtilsProvider>
	);
}
